/**
 * Validation errors are formatted as `<panelName>.<panelField>`,
 * which requires some logic to extract the panel name
 * @param { Array<string> } fieldsWithErrors
 * @returns { Array<string>} An array of panel names as strings
 */
export const formatValidationErrors = (
  fieldsWithErrors: Array<string>,
): Array<string> => {
  const panelNames = fieldsWithErrors.map((fieldWithError) => {
    const [panelNameSegment] = fieldWithError.split('.');
    return panelNameSegment;
  });
  // Removes duplicate panel names
  return [...new Set(panelNames)];
};
